export const nodeStateChange = (setNodeState: any, body: any, id: string) => {
  if (setNodeState) {
    setNodeState((nds: any) => {
      return nds?.map((nd: any) => {
        if (nd.id === id) {
          return {
            ...nd,
            data: {
              ...nd.data,
              ...body,
            },
          };
        }
        return nd;
      });
    });
  }
};
